import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DownloadAllStatus } from '@shared/models/download-all-status';
import { Observable } from 'rxjs';
import { CommonService } from './common.service';
import downloadAllStatusMock from '@mocks/getDownloadAllStatus.json';

@Injectable({
  providedIn: 'root'
})
export class CorrespondenceService {

  private downloadAllStatus: DownloadAllStatus;

  constructor(
    private commonService: CommonService,
    private http: HttpClient
  ) {
    this.downloadAllStatus = downloadAllStatusMock;
   }

  public postDownloadAll(policyNumber: string): Observable<DownloadAllStatus> {
    if (this.commonService.useMocks) {
      return new Observable(observer => observer.next(this.downloadAllStatus))
    }
    return this.http.post<DownloadAllStatus>(this.commonService.getServiceUrl('correspondence/download-all'), { 'policyNumber': policyNumber });
  }
}
